export const translations = {
  de: {
    // App
    app_name: "Athlo Nexus",
    app_subtitle: "Studio Manager",
    app_tagline: "Verwalten Sie Ihr Studio effizient",
    app_hero: "Organisieren Sie Ihr Team effizient",
    app_hero_sub: "Vollständiges Verwaltungssystem für Studios",

    // Auth
    login_title: "In Ihr Konto einloggen",
    register_title: "Konto erstellen",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    login_btn: "Anmelden",
    register_btn: "Konto erstellen",
    loading: "Laden...",
    no_account: "Noch kein Konto? Registrieren",
    have_account: "Haben Sie bereits ein Konto? Anmelden",
    login_success: "Erfolgreich angemeldet!",
    register_success: "Konto erfolgreich erstellt!",
    auth_error: "Fehler bei der Authentifizierung",
    session_expired: "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",

    // Nav
    nav_dashboard: "Tagesübersicht",
    nav_calendar: "Kalender",
    nav_weekly: "Wochenansicht",
    nav_bioimpedance: "Bioimpedanz",
    nav_social_media: "Social Media",
    nav_ai_chat: "KI-Chat",
    nav_inventory: "Lagerbestand",
    nav_workers: "Mitarbeiter",
    nav_shift_types: "Schichttypen",
    nav_training_plans: "Trainingsplaner",
    nav_nutrition: "Ernährungsplan",
    nav_anamnese: "Anamnese",
    nav_statistics: "Statistiken",
    nav_integrations: "Integrationen",
    nav_revenue: "Umsatz-Dashboard",
    logout: "Abmelden",
    expand_menu: "Menü erweitern",
    collapse_menu: "Menü verkleinern",

    // Calendar
    calendar_title: "Kalender",
    add_shift: "Schicht hinzufügen",
    add_absence: "Abwesenheit hinzufügen",
    add_task: "Aufgabe hinzufügen",
    add_note: "Notiz hinzufügen",
    add_reminder: "Erinnerung hinzufügen",
    shift_planning: "Schichtplanung",
    manager: "Manager",
    custom_time: "Benutzerdefinierte Zeit",
    absence: "Abwesenheit",
    task: "Aufgabe",
    reminder: "Erinnerung",
    compact_view: "Kompaktansicht",
    expanded_view: "Erweiterte Ansicht",
    download_pdf: "PDF herunterladen",
    export_shifts: "Schichten exportieren",

    // Manager / Dashboard
    dashboard_title: "Tagesübersicht",
    trainings_today: "Trainings heute",
    pending_tasks: "Offene Aufgaben",
    overdue: "Überfällig",
    high_priority: "Hohe Priorität",
    low_stock: "Lager niedrig",
    reminders_label: "Erinnerungen",
    out_of_stock: "Ausverkauft!",
    products_below_target: "Produkte unter Sollbestand",
    more: "weitere",
    go_to_inventory: "Zum Lager",
    bio_notifications: "Bioimpedanz-Hinweise",
    go_to_bio: "Zur Bioimpedanz",
    tasks_section: "Aufgaben",
    notes_section: "Notizen",
    reminders_section: "Kunden-Erinnerungen",
    pinned_notes: "Angeheftete Notizen",
    all_tasks: "Alle Aufgaben",
    add: "Hinzufügen",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    create: "Erstellen",
    edit: "Bearbeiten",
    title: "Titel",
    description: "Beschreibung",
    priority: "Priorität",
    priority_high: "Hoch",
    priority_medium: "Mittel",
    priority_low: "Niedrig",
    category: "Kategorie",
    cat_general: "Allgemein",
    cat_client: "Kunden",
    cat_equipment: "Geräte",
    cat_inventory: "Lager",
    cat_staff: "Personal",
    cat_marketing: "Marketing",
    cat_finance: "Finanzen",
    cat_meeting: "Meeting",
    cat_idea: "Ideen",
    due_date: "Fälligkeitsdatum",
    recurring: "Wiederkehrend",
    recurrence_daily: "Täglich",
    recurrence_weekly: "Wöchentlich",
    recurrence_monthly: "Monatlich",
    content: "Inhalt",
    pin_note: "Notiz anheften",
    client_name: "Kundenname",
    reminder_type: "Erinnerungstyp",
    type_follow_up: "Nachverfolgung",
    type_birthday: "Geburtstag",
    type_renewal: "Verlängerung",
    type_feedback: "Feedback",
    note: "Notiz",
    new_task: "Neue Aufgabe",
    new_note: "Neue Notiz",
    new_reminder: "Neue Kunden-Erinnerung",
    what_needs_done: "Was muss erledigt werden?",
    your_note: "Ihre Notiz...",
    client_name_placeholder: "Name des Kunden",
    additional_info: "Zusätzliche Informationen...",
    details: "Details...",

    // Inventory
    inventory_title: "Lagerbestand",
    inventory_subtitle: "Produkte und Material verwalten",
    search: "Suchen...",
    all_categories: "Alle Kategorien",
    product: "Produkt",
    current_stock: "Ist-Bestand",
    target_stock: "Soll-Bestand",
    status: "Status",
    actions: "Aktionen",
    ok: "OK",
    low: "Niedrig",
    empty: "Leer",
    auto_populate: "Auto-Befüllen",
    add_product: "Produkt hinzufügen",
    product_name: "Produktname",
    unit: "Einheit",

    // Workers
    workers_title: "Mitarbeiter",
    workers_subtitle: "Teammitglieder verwalten",
    add_worker: "Mitarbeiter hinzufügen",
    position: "Position",
    phone: "Telefon",

    // Shift Types
    shift_types_title: "Schichttypen",
    shift_types_subtitle: "Arbeitszeiten konfigurieren",
    add_shift_type: "Typ hinzufügen",
    start_time: "Startzeit",
    end_time: "Endzeit",
    color: "Farbe",

    // Statistics
    statistics_title: "Statistiken",
    statistics_subtitle: "Übersicht und Auswertungen",
    total_shifts: "Gesamt Schichten",
    total_absences: "Gesamt Abwesenheiten",

    // Integrations
    integrations_title: "Integrationen",
    integrations_subtitle: "Verbinden Sie externe Dienste",
    calendar_export: "Kalender Export",
    calendar_export_desc: "Exportieren Sie Daten für Google Kalender",
    month: "Monat",
    data: "Daten",
    all_data: "Alles (Schichten + Abwesenheiten)",
    only_shifts: "Nur Schichten",
    google_import_title: "So importieren Sie in Google Kalender:",
    google_import_1: "ICS-Datei herunterladen",
    google_import_2: "Google Kalender öffnen → Einstellungen",
    google_import_3: "Import & Export → Datei auswählen",
    google_import_4: "Kalender auswählen → Importieren",
    download_ics: "ICS-Datei herunterladen",
    google_calendar_api: "Google Kalender API",
    google_calendar_desc: "Direkte Synchronisierung (erweitert)",
    connected: "Verbunden",
    not_connected: "Nicht verbunden",
    sync: "Synchronisieren",
    disconnect: "Trennen",
    connect_google: "Mit Google verbinden",
    google_connected_success: "Google Kalender erfolgreich verbunden!",
    download_success: "Kalender heruntergeladen!",
    download_error: "Fehler beim Herunterladen",

    // Bioimpedance
    bio_title: "Bioimpedanz-Analyse",
    bio_subtitle: "Kundenkörperanalyse verwalten",
    add_client: "Neuer Kunde",
    first_name: "Vorname",
    last_name: "Nachname",
    date_of_birth: "Geburtsdatum",
    height: "Größe (cm)",
    next_assessment: "Nächste Bewertung",
    measurements: "Messungen",
    goals: "Ziele",
    add_measurement: "Messung hinzufügen",
    add_goal: "Ziel hinzufügen",
    weight: "Gewicht",
    body_fat: "Körperfett",
    muscle_mass: "Muskelmasse",
    visceral_fat: "Viszerales Fett",
    fat_mass: "Fettmasse",
    water_content: "Wassergehalt",
    date: "Datum",
    pdf_language: "Sprache / Language",

    // Social Media
    social_title: "Social Media Planer",
    social_subtitle: "Wöchentliche Content-Planung",
    generate_plan: "Plan generieren",
    new_plan: "Neuer Wochenplan",
    theme: "Thema",
    or_url: "Oder Website-URL",
    posts: "Posts",
    reel: "Reel",

    // AI Chat
    chat_title: "KI-Chat",
    new_conversation: "Neues Gespräch",
    search_conversations: "Suchen...",
    no_conversations: "Keine Gespräche",
    chats: "Chats",
    gallery: "Galerie",
    enter_message: "Nachricht eingeben...",
    thinking: "Denkt nach...",
    attach_file: "Datei anhängen",
    copy: "Kopieren",
    copied: "Kopiert!",
    ai_disclaimer: "kann Fehler machen. Überprüfe wichtige Informationen.",
    no_images: "Keine Bilder",
    no_images_desc: "Verwende das Modell Nano Banana um Bilder zu generieren. Alle generierten Bilder erscheinen hier.",
    image_gallery: "Bildergalerie",
    images_generated: "Bilder generiert",
    download_image: "Bild herunterladen",
    copy_prompt: "Prompt kopieren",
    prompt_copied: "Prompt kopiert!",
    go_to_conversation: "Zum Gespräch",
    generated_image: "Generiertes Bild",
    image_generated_text: "Bild wurde generiert.",

    // Weekly View
    weekly_title: "Wochenansicht",
    week: "Woche",

    // Common
    error: "Fehler",
    success: "Erfolg",
    confirm: "Bestätigen",
    close: "Schließen",
    yes: "Ja",
    no: "Nein",
    no_data: "Keine Daten",
    language: "Sprache",
    update: "Aktualisieren",
    manage_team: "Verwalten Sie Ihr Team",
    no_workers: "Keine Mitarbeiter registriert.",
    add_first_worker: "Ersten Mitarbeiter hinzufügen",
    edit_worker: "Mitarbeiter bearbeiten",
    role: "Rolle",
    confirm_delete_worker: "Sind Sie sicher, dass Sie diesen Mitarbeiter löschen möchten?",
    worker_deleted: "Mitarbeiter gelöscht!",
    worker_saved: "Mitarbeiter gespeichert!",
    configure_schedules: "Arbeitszeiten konfigurieren",
    no_shift_types: "Keine Schichttypen definiert.",
    add_first_type: "Ersten Typ hinzufügen",
    edit_shift_type: "Schichttyp bearbeiten",
    shift_type_name: "Name des Schichttyps",
    overview_reports: "Übersicht und Auswertungen",
    no_stats_data: "Keine Daten für den ausgewählten Monat.",
    worker_label: "Mitarbeiter",
    shifts_count: "Schichten",
    hours: "Stunden",
    total: "Gesamt",
    week_of: "Woche vom",

    // Landing Page
    landing_hero_title: "Das All-in-One Studio Management",
    landing_hero_subtitle: "Turnos, Inventar, Bioimpedanz, Social Media und KI-Chat in einer Plattform. Optimieren Sie Ihren Studioalltag.",
    landing_cta: "Jetzt starten",
    landing_cta_login: "Anmelden",
    landing_features_title: "Alles, was Ihr Studio braucht",
    landing_features_subtitle: "Leistungsstarke Tools für moderne Studios",
    landing_pricing_title: "Einfache, transparente Preise",
    landing_pricing_subtitle: "Wählen Sie den Plan, der zu Ihnen passt",
    landing_monthly: "Monatlich",
    landing_annual: "Jährlich",
    landing_annual_save: "2 Monate gratis",
    landing_per_month: "/Monat",
    landing_per_year: "/Jahr",
    landing_popular: "Beliebt",
    landing_start_trial: "Jetzt starten",
    landing_subscribe: "Jetzt abonnieren",
    landing_faq_title: "Häufig gestellte Fragen",
    landing_faq_1_q: "Kann ich jederzeit kündigen?",
    landing_faq_1_a: "Ja, Sie können Ihr Abonnement jederzeit kündigen. Ihre Funktionen bleiben bis zum Ende des Abrechnungszeitraums aktiv.",
    landing_faq_2_q: "Wie funktioniert der Einstieg?",
    landing_faq_2_a: "Wählen Sie einfach einen Plan und starten Sie sofort mit allen Funktionen Ihres gewählten Pakets.",
    landing_faq_3_q: "Kann ich den Plan wechseln?",
    landing_faq_3_a: "Ja, Sie können jederzeit zwischen Basic und Premium wechseln oder Ihr Abonnement kündigen.",
    landing_faq_4_q: "Kann ich meinen Plan upgraden?",
    landing_faq_4_a: "Ja, Sie können jederzeit vom Basic- auf den Premium-Plan upgraden.",
    landing_footer: "Athlo Nexus Studio Manager",
    landing_all_rights: "Alle Rechte vorbehalten.",
    upgrade_required: "Upgrade erforderlich",
    upgrade_message: "Diese Funktion ist im Premium-Plan verfügbar.",
    upgrade_btn: "Auf Premium upgraden",
    subscription_active: "Aktives Abonnement",
    no_subscription: "Kein Abonnement",

    // CRM & Email
    nav_crm: "Kunden-CRM",
    crm_title: "Kundendatenbank",
    crm_subtitle: "Kundendaten und E-Mail-Verwaltung",
    add_client_crm: "Neuer Kunde",
    edit_client_crm: "Kunde bearbeiten",
    gender: "Geschlecht",
    gender_m: "Männlich",
    gender_f: "Weiblich",
    gender_d: "Divers",
    address: "Adresse",
    notes_field: "Notizen",
    link_bio: "Bioimpedanz verknüpfen",
    linked_bio: "Bioimpedanz verknüpft",
    no_clients: "Keine Kunden registriert",
    email_templates: "E-Mail-Vorlagen",
    new_template: "Neue Vorlage",
    edit_template: "Vorlage bearbeiten",
    template_name: "Vorlagenname",
    subject: "Betreff",
    body: "Inhalt",
    automated: "Automatisiert",
    trigger_type: "Auslöser",
    trigger_birthday: "Geburtstag",
    trigger_assessment: "Bewertungserinnerung",
    trigger_welcome: "Willkommen",
    trigger_custom: "Benutzerdefiniert",
    days_before: "Tage vorher",
    send_email: "E-Mail senden",
    send_to_selected: "An ausgewählte senden",
    generate_with_ai: "Mit KI generieren",
    ai_prompt: "Beschreiben Sie die E-Mail...",
    email_logs: "E-Mail-Verlauf",
    queued: "In Warteschlange",
    sent: "Gesendet",
    clients_tab: "Kunden",
    emails_tab: "E-Mails",
    templates_tab: "Vorlagen",
    select_all: "Alle auswählen",
    no_email: "Keine E-Mail",
  },

  en: {
    app_name: "Athlo Nexus",
    app_subtitle: "Studio Manager",
    app_tagline: "Manage your studio efficiently",
    app_hero: "Organize your team efficiently",
    app_hero_sub: "Complete management system for studios",

    login_title: "Sign in to your account",
    register_title: "Create account",
    email: "Email",
    password: "Password",
    name: "Name",
    login_btn: "Sign in",
    register_btn: "Create account",
    loading: "Loading...",
    no_account: "Don't have an account? Register",
    have_account: "Already have an account? Sign in",
    login_success: "Successfully logged in!",
    register_success: "Account successfully created!",
    auth_error: "Authentication error",
    session_expired: "Session expired. Please sign in again.",

    nav_dashboard: "Dashboard",
    nav_calendar: "Calendar",
    nav_weekly: "Weekly View",
    nav_bioimpedance: "Bioimpedance",
    nav_social_media: "Social Media",
    nav_ai_chat: "AI Chat",
    nav_inventory: "Inventory",
    nav_workers: "Staff",
    nav_shift_types: "Shift Types",
    nav_training_plans: "Training Planner",
    nav_nutrition: "Nutrition Plan",
    nav_anamnese: "Anamnesis",
    nav_statistics: "Statistics",
    nav_integrations: "Integrations",
    nav_revenue: "Revenue Dashboard",
    logout: "Sign out",
    expand_menu: "Expand menu",
    collapse_menu: "Collapse menu",

    calendar_title: "Calendar",
    add_shift: "Add shift",
    add_absence: "Add absence",
    add_task: "Add task",
    add_note: "Add note",
    add_reminder: "Add reminder",
    shift_planning: "Shift Planning",
    manager: "Manager",
    custom_time: "Custom time",
    absence: "Absence",
    task: "Task",
    reminder: "Reminder",
    compact_view: "Compact view",
    expanded_view: "Expanded view",
    download_pdf: "Download PDF",
    export_shifts: "Export shifts",

    dashboard_title: "Dashboard",
    trainings_today: "Trainings today",
    pending_tasks: "Pending tasks",
    overdue: "Overdue",
    high_priority: "High priority",
    low_stock: "Low stock",
    reminders_label: "Reminders",
    out_of_stock: "Out of stock!",
    products_below_target: "Products below target",
    more: "more",
    go_to_inventory: "Go to inventory",
    bio_notifications: "Bioimpedance alerts",
    go_to_bio: "Go to bioimpedance",
    tasks_section: "Tasks",
    notes_section: "Notes",
    reminders_section: "Client Reminders",
    pinned_notes: "Pinned Notes",
    all_tasks: "All Tasks",
    add: "Add",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    edit: "Edit",
    title: "Title",
    description: "Description",
    priority: "Priority",
    priority_high: "High",
    priority_medium: "Medium",
    priority_low: "Low",
    category: "Category",
    cat_general: "General",
    cat_client: "Clients",
    cat_equipment: "Equipment",
    cat_inventory: "Inventory",
    cat_staff: "Staff",
    cat_marketing: "Marketing",
    cat_finance: "Finance",
    cat_meeting: "Meeting",
    cat_idea: "Ideas",
    due_date: "Due date",
    recurring: "Recurring",
    recurrence_daily: "Daily",
    recurrence_weekly: "Weekly",
    recurrence_monthly: "Monthly",
    content: "Content",
    pin_note: "Pin note",
    client_name: "Client name",
    reminder_type: "Reminder type",
    type_follow_up: "Follow-up",
    type_birthday: "Birthday",
    type_renewal: "Renewal",
    type_feedback: "Feedback",
    note: "Note",
    new_task: "New Task",
    new_note: "New Note",
    new_reminder: "New Client Reminder",
    what_needs_done: "What needs to be done?",
    your_note: "Your note...",
    client_name_placeholder: "Client name",
    additional_info: "Additional information...",
    details: "Details...",

    inventory_title: "Inventory",
    inventory_subtitle: "Manage products and materials",
    search: "Search...",
    all_categories: "All categories",
    product: "Product",
    current_stock: "Current stock",
    target_stock: "Target stock",
    status: "Status",
    actions: "Actions",
    ok: "OK",
    low: "Low",
    empty: "Empty",
    auto_populate: "Auto-populate",
    add_product: "Add product",
    product_name: "Product name",
    unit: "Unit",

    workers_title: "Staff",
    workers_subtitle: "Manage team members",
    add_worker: "Add staff member",
    position: "Position",
    phone: "Phone",

    shift_types_title: "Shift Types",
    shift_types_subtitle: "Configure work schedules",
    add_shift_type: "Add type",
    start_time: "Start time",
    end_time: "End time",
    color: "Color",

    statistics_title: "Statistics",
    statistics_subtitle: "Overview and reports",
    total_shifts: "Total shifts",
    total_absences: "Total absences",

    integrations_title: "Integrations",
    integrations_subtitle: "Connect external services",
    calendar_export: "Calendar Export",
    calendar_export_desc: "Export data for Google Calendar",
    month: "Month",
    data: "Data",
    all_data: "All (Shifts + Absences)",
    only_shifts: "Shifts only",
    google_import_title: "How to import into Google Calendar:",
    google_import_1: "Download ICS file",
    google_import_2: "Open Google Calendar → Settings",
    google_import_3: "Import & Export → Select file",
    google_import_4: "Select calendar → Import",
    download_ics: "Download ICS file",
    google_calendar_api: "Google Calendar API",
    google_calendar_desc: "Direct synchronization (advanced)",
    connected: "Connected",
    not_connected: "Not connected",
    sync: "Sync",
    disconnect: "Disconnect",
    connect_google: "Connect to Google",
    google_connected_success: "Google Calendar connected successfully!",
    download_success: "Calendar downloaded!",
    download_error: "Download error",

    bio_title: "Bioimpedance Analysis",
    bio_subtitle: "Manage client body analysis",
    add_client: "New Client",
    first_name: "First Name",
    last_name: "Last Name",
    date_of_birth: "Date of Birth",
    height: "Height (cm)",
    next_assessment: "Next Assessment",
    measurements: "Measurements",
    goals: "Goals",
    add_measurement: "Add measurement",
    add_goal: "Add goal",
    weight: "Weight",
    body_fat: "Body Fat",
    muscle_mass: "Muscle Mass",
    visceral_fat: "Visceral Fat",
    fat_mass: "Fat Mass",
    water_content: "Water Content",
    date: "Date",
    pdf_language: "Language",

    social_title: "Social Media Planner",
    social_subtitle: "Weekly content planning",
    generate_plan: "Generate plan",
    new_plan: "New Week Plan",
    theme: "Theme",
    or_url: "Or website URL",
    posts: "Posts",
    reel: "Reel",

    chat_title: "AI Chat",
    new_conversation: "New Conversation",
    search_conversations: "Search...",
    no_conversations: "No conversations",
    chats: "Chats",
    gallery: "Gallery",
    enter_message: "Enter message...",
    thinking: "Thinking...",
    attach_file: "Attach file",
    copy: "Copy",
    copied: "Copied!",
    ai_disclaimer: "may make mistakes. Verify important information.",
    no_images: "No images",
    no_images_desc: "Use the Nano Banana model to generate images. All generated images will appear here.",
    image_gallery: "Image Gallery",
    images_generated: "images generated",
    download_image: "Download image",
    copy_prompt: "Copy prompt",
    prompt_copied: "Prompt copied!",
    go_to_conversation: "Go to conversation",
    generated_image: "Generated image",
    image_generated_text: "Image was generated.",

    weekly_title: "Weekly View",
    week: "Week",

    error: "Error",
    success: "Success",
    confirm: "Confirm",
    close: "Close",
    yes: "Yes",
    no: "No",
    no_data: "No data",
    language: "Language",
    update: "Update",
    manage_team: "Manage your team",
    no_workers: "No staff members registered.",
    add_first_worker: "Add first staff member",
    edit_worker: "Edit staff member",
    role: "Role",
    confirm_delete_worker: "Are you sure you want to delete this staff member?",
    worker_deleted: "Staff member deleted!",
    worker_saved: "Staff member saved!",
    configure_schedules: "Configure work schedules",
    no_shift_types: "No shift types defined.",
    add_first_type: "Add first type",
    edit_shift_type: "Edit shift type",
    shift_type_name: "Shift type name",
    overview_reports: "Overview and reports",
    no_stats_data: "No data for selected month.",
    worker_label: "Worker",
    shifts_count: "Shifts",
    hours: "Hours",
    total: "Total",
    week_of: "Week of",

    landing_hero_title: "The All-in-One Studio Management",
    landing_hero_subtitle: "Shifts, inventory, bioimpedance, social media and AI chat in one platform. Optimize your studio operations.",
    landing_cta: "Get started",
    landing_cta_login: "Sign in",
    landing_features_title: "Everything your studio needs",
    landing_features_subtitle: "Powerful tools for modern studios",
    landing_pricing_title: "Simple, transparent pricing",
    landing_pricing_subtitle: "Choose the plan that fits you",
    landing_monthly: "Monthly",
    landing_annual: "Annual",
    landing_annual_save: "2 months free",
    landing_per_month: "/month",
    landing_per_year: "/year",
    landing_popular: "Popular",
    landing_start_trial: "Get started now",
    landing_subscribe: "Subscribe now",
    landing_faq_title: "Frequently asked questions",
    landing_faq_1_q: "Can I cancel anytime?",
    landing_faq_1_a: "Yes, you can cancel your subscription at any time. Features remain active until the end of the billing period.",
    landing_faq_2_q: "How do I get started?",
    landing_faq_2_a: "Simply choose a plan and start using all features included in your package right away.",
    landing_faq_3_q: "Can I switch plans?",
    landing_faq_3_a: "Yes, you can switch between Basic and Premium or cancel your subscription at any time.",
    landing_faq_4_q: "Can I upgrade my plan?",
    landing_faq_4_a: "Yes, you can upgrade from Basic to Premium at any time.",
    landing_footer: "Athlo Nexus Studio Manager",
    landing_all_rights: "All rights reserved.",
    upgrade_required: "Upgrade required",
    upgrade_message: "This feature is available in the Premium plan.",
    upgrade_btn: "Upgrade to Premium",
    subscription_active: "Active subscription",
    no_subscription: "No subscription",

    nav_crm: "Client CRM",
    crm_title: "Client Database",
    crm_subtitle: "Client data and email management",
    add_client_crm: "New Client",
    edit_client_crm: "Edit Client",
    gender: "Gender",
    gender_m: "Male",
    gender_f: "Female",
    gender_d: "Diverse",
    address: "Address",
    notes_field: "Notes",
    link_bio: "Link Bioimpedance",
    linked_bio: "Bioimpedance linked",
    no_clients: "No clients registered",
    email_templates: "Email Templates",
    new_template: "New Template",
    edit_template: "Edit Template",
    template_name: "Template name",
    subject: "Subject",
    body: "Body",
    automated: "Automated",
    trigger_type: "Trigger",
    trigger_birthday: "Birthday",
    trigger_assessment: "Assessment reminder",
    trigger_welcome: "Welcome",
    trigger_custom: "Custom",
    days_before: "Days before",
    send_email: "Send email",
    send_to_selected: "Send to selected",
    generate_with_ai: "Generate with AI",
    ai_prompt: "Describe the email...",
    email_logs: "Email history",
    queued: "Queued",
    sent: "Sent",
    clients_tab: "Clients",
    emails_tab: "Emails",
    templates_tab: "Templates",
    select_all: "Select all",
    no_email: "No email",
  },

  pt: {
    app_name: "Athlo Nexus",
    app_subtitle: "Studio Manager",
    app_tagline: "Gerencie seu estúdio com eficiência",
    app_hero: "Organize sua equipe com eficiência",
    app_hero_sub: "Sistema completo de gestão para estúdios",

    login_title: "Entrar na sua conta",
    register_title: "Criar conta",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    login_btn: "Entrar",
    register_btn: "Criar conta",
    loading: "Carregando...",
    no_account: "Não tem conta? Registre-se",
    have_account: "Já tem uma conta? Entrar",
    login_success: "Login realizado com sucesso!",
    register_success: "Conta criada com sucesso!",
    auth_error: "Erro de autenticação",
    session_expired: "Sessão expirada. Por favor, faça login novamente.",

    nav_dashboard: "Visão Geral",
    nav_calendar: "Calendário",
    nav_weekly: "Visão Semanal",
    nav_bioimpedance: "Bioimpedância",
    nav_social_media: "Social Media",
    nav_ai_chat: "Chat IA",
    nav_inventory: "Estoque",
    nav_workers: "Equipe",
    nav_shift_types: "Tipos de Turno",
    nav_training_plans: "Planejador de Treino",
    nav_nutrition: "Plano Nutricional",
    nav_anamnese: "Anamnese",
    nav_statistics: "Estatísticas",
    nav_integrations: "Integrações",
    nav_revenue: "Painel de Receitas",
    logout: "Sair",
    expand_menu: "Expandir menu",
    collapse_menu: "Recolher menu",

    calendar_title: "Calendário",
    add_shift: "Adicionar turno",
    add_absence: "Adicionar ausência",
    add_task: "Adicionar tarefa",
    add_note: "Adicionar nota",
    add_reminder: "Adicionar lembrete",
    shift_planning: "Planejamento de Turnos",
    manager: "Gerente",
    custom_time: "Horário personalizado",
    absence: "Ausência",
    task: "Tarefa",
    reminder: "Lembrete",
    compact_view: "Visão compacta",
    expanded_view: "Visão expandida",
    download_pdf: "Baixar PDF",
    export_shifts: "Exportar turnos",

    dashboard_title: "Visão Geral",
    trainings_today: "Treinos hoje",
    pending_tasks: "Tarefas pendentes",
    overdue: "Atrasadas",
    high_priority: "Alta prioridade",
    low_stock: "Estoque baixo",
    reminders_label: "Lembretes",
    out_of_stock: "Esgotado!",
    products_below_target: "Produtos abaixo do alvo",
    more: "mais",
    go_to_inventory: "Ir ao estoque",
    bio_notifications: "Alertas de bioimpedância",
    go_to_bio: "Ir à bioimpedância",
    tasks_section: "Tarefas",
    notes_section: "Notas",
    reminders_section: "Lembretes de Clientes",
    pinned_notes: "Notas Fixadas",
    all_tasks: "Todas as Tarefas",
    add: "Adicionar",
    delete: "Excluir",
    save: "Salvar",
    cancel: "Cancelar",
    create: "Criar",
    edit: "Editar",
    title: "Título",
    description: "Descrição",
    priority: "Prioridade",
    priority_high: "Alta",
    priority_medium: "Média",
    priority_low: "Baixa",
    category: "Categoria",
    cat_general: "Geral",
    cat_client: "Clientes",
    cat_equipment: "Equipamentos",
    cat_inventory: "Estoque",
    cat_staff: "Equipe",
    cat_marketing: "Marketing",
    cat_finance: "Finanças",
    cat_meeting: "Reunião",
    cat_idea: "Ideias",
    due_date: "Data de vencimento",
    recurring: "Recorrente",
    recurrence_daily: "Diário",
    recurrence_weekly: "Semanal",
    recurrence_monthly: "Mensal",
    content: "Conteúdo",
    pin_note: "Fixar nota",
    client_name: "Nome do cliente",
    reminder_type: "Tipo de lembrete",
    type_follow_up: "Acompanhamento",
    type_birthday: "Aniversário",
    type_renewal: "Renovação",
    type_feedback: "Feedback",
    note: "Nota",
    new_task: "Nova Tarefa",
    new_note: "Nova Nota",
    new_reminder: "Novo Lembrete de Cliente",
    what_needs_done: "O que precisa ser feito?",
    your_note: "Sua nota...",
    client_name_placeholder: "Nome do cliente",
    additional_info: "Informações adicionais...",
    details: "Detalhes...",

    inventory_title: "Estoque",
    inventory_subtitle: "Gerenciar produtos e materiais",
    search: "Buscar...",
    all_categories: "Todas as categorias",
    product: "Produto",
    current_stock: "Estoque atual",
    target_stock: "Estoque alvo",
    status: "Status",
    actions: "Ações",
    ok: "OK",
    low: "Baixo",
    empty: "Vazio",
    auto_populate: "Auto-preencher",
    add_product: "Adicionar produto",
    product_name: "Nome do produto",
    unit: "Unidade",

    workers_title: "Equipe",
    workers_subtitle: "Gerenciar membros da equipe",
    add_worker: "Adicionar membro",
    position: "Cargo",
    phone: "Telefone",

    shift_types_title: "Tipos de Turno",
    shift_types_subtitle: "Configurar horários de trabalho",
    add_shift_type: "Adicionar tipo",
    start_time: "Hora de início",
    end_time: "Hora de término",
    color: "Cor",

    statistics_title: "Estatísticas",
    statistics_subtitle: "Visão geral e relatórios",
    total_shifts: "Total de turnos",
    total_absences: "Total de ausências",

    integrations_title: "Integrações",
    integrations_subtitle: "Conectar serviços externos",
    calendar_export: "Exportar Calendário",
    calendar_export_desc: "Exportar dados para Google Calendar",
    month: "Mês",
    data: "Dados",
    all_data: "Tudo (Turnos + Ausências)",
    only_shifts: "Apenas turnos",
    google_import_title: "Como importar no Google Calendar:",
    google_import_1: "Baixar arquivo ICS",
    google_import_2: "Abrir Google Calendar → Configurações",
    google_import_3: "Importar & Exportar → Selecionar arquivo",
    google_import_4: "Selecionar calendário → Importar",
    download_ics: "Baixar arquivo ICS",
    google_calendar_api: "Google Calendar API",
    google_calendar_desc: "Sincronização direta (avançado)",
    connected: "Conectado",
    not_connected: "Não conectado",
    sync: "Sincronizar",
    disconnect: "Desconectar",
    connect_google: "Conectar ao Google",
    google_connected_success: "Google Calendar conectado com sucesso!",
    download_success: "Calendário baixado!",
    download_error: "Erro no download",

    bio_title: "Análise de Bioimpedância",
    bio_subtitle: "Gerenciar análise corporal dos clientes",
    add_client: "Novo Cliente",
    first_name: "Nome",
    last_name: "Sobrenome",
    date_of_birth: "Data de Nascimento",
    height: "Altura (cm)",
    next_assessment: "Próxima Avaliação",
    measurements: "Medições",
    goals: "Metas",
    add_measurement: "Adicionar medição",
    add_goal: "Adicionar meta",
    weight: "Peso",
    body_fat: "Gordura Corporal",
    muscle_mass: "Massa Muscular",
    visceral_fat: "Gordura Visceral",
    fat_mass: "Massa Gorda",
    water_content: "Conteúdo de Água",
    date: "Data",
    pdf_language: "Idioma",

    social_title: "Planejador Social Media",
    social_subtitle: "Planejamento semanal de conteúdo",
    generate_plan: "Gerar plano",
    new_plan: "Novo Plano Semanal",
    theme: "Tema",
    or_url: "Ou URL do site",
    posts: "Posts",
    reel: "Reel",

    chat_title: "Chat IA",
    new_conversation: "Nova Conversa",
    search_conversations: "Buscar...",
    no_conversations: "Sem conversas",
    chats: "Chats",
    gallery: "Galeria",
    enter_message: "Digite uma mensagem...",
    thinking: "Pensando...",
    attach_file: "Anexar arquivo",
    copy: "Copiar",
    copied: "Copiado!",
    ai_disclaimer: "pode cometer erros. Verifique informações importantes.",
    no_images: "Sem imagens",
    no_images_desc: "Use o modelo Nano Banana para gerar imagens. Todas as imagens geradas aparecerão aqui.",
    image_gallery: "Galeria de Imagens",
    images_generated: "imagens geradas",
    download_image: "Baixar imagem",
    copy_prompt: "Copiar prompt",
    prompt_copied: "Prompt copiado!",
    go_to_conversation: "Ir à conversa",
    generated_image: "Imagem gerada",
    image_generated_text: "Imagem foi gerada.",

    weekly_title: "Visão Semanal",
    week: "Semana",

    error: "Erro",
    success: "Sucesso",
    confirm: "Confirmar",
    close: "Fechar",
    yes: "Sim",
    no: "Não",
    no_data: "Sem dados",
    language: "Idioma",
    update: "Atualizar",
    manage_team: "Gerencie sua equipe",
    no_workers: "Nenhum membro registrado.",
    add_first_worker: "Adicionar primeiro membro",
    edit_worker: "Editar membro",
    role: "Função",
    confirm_delete_worker: "Tem certeza de que deseja excluir este membro?",
    worker_deleted: "Membro excluído!",
    worker_saved: "Membro salvo!",
    configure_schedules: "Configurar horários de trabalho",
    no_shift_types: "Nenhum tipo de turno definido.",
    add_first_type: "Adicionar primeiro tipo",
    edit_shift_type: "Editar tipo de turno",
    shift_type_name: "Nome do tipo de turno",
    overview_reports: "Visão geral e relatórios",
    no_stats_data: "Sem dados para o mês selecionado.",
    worker_label: "Trabalhador",
    shifts_count: "Turnos",
    hours: "Horas",
    total: "Total",
    week_of: "Semana de",

    landing_hero_title: "A Gestão Completa do Seu Estúdio",
    landing_hero_subtitle: "Turnos, estoque, bioimpedância, social media e chat IA em uma plataforma. Otimize o dia a dia do seu estúdio.",
    landing_cta: "Começar agora",
    landing_cta_login: "Entrar",
    landing_features_title: "Tudo que seu estúdio precisa",
    landing_features_subtitle: "Ferramentas poderosas para estúdios modernos",
    landing_pricing_title: "Preços simples e transparentes",
    landing_pricing_subtitle: "Escolha o plano ideal para você",
    landing_monthly: "Mensal",
    landing_annual: "Anual",
    landing_annual_save: "2 meses grátis",
    landing_per_month: "/mês",
    landing_per_year: "/ano",
    landing_popular: "Popular",
    landing_start_trial: "Começar agora",
    landing_subscribe: "Assinar agora",
    landing_faq_title: "Perguntas frequentes",
    landing_faq_1_q: "Posso cancelar a qualquer momento?",
    landing_faq_1_a: "Sim, você pode cancelar sua assinatura a qualquer momento. As funcionalidades permanecem ativas até o final do período.",
    landing_faq_2_q: "Como começo a usar?",
    landing_faq_2_a: "Escolha um plano e comece a usar todas as funcionalidades do seu pacote imediatamente.",
    landing_faq_3_q: "Posso trocar de plano?",
    landing_faq_3_a: "Sim, você pode trocar entre Basic e Premium ou cancelar sua assinatura a qualquer momento.",
    landing_faq_4_q: "Posso fazer upgrade do meu plano?",
    landing_faq_4_a: "Sim, você pode fazer upgrade do Basic para Premium a qualquer momento.",
    landing_footer: "Athlo Nexus Studio Manager",
    landing_all_rights: "Todos os direitos reservados.",
    upgrade_required: "Upgrade necessário",
    upgrade_message: "Esta funcionalidade está disponível no plano Premium.",
    upgrade_btn: "Fazer upgrade para Premium",
    subscription_active: "Assinatura ativa",
    no_subscription: "Sem assinatura",

    nav_crm: "CRM Clientes",
    crm_title: "Banco de Dados de Clientes",
    crm_subtitle: "Dados de clientes e gerenciamento de e-mails",
    add_client_crm: "Novo Cliente",
    edit_client_crm: "Editar Cliente",
    gender: "Sexo",
    gender_m: "Masculino",
    gender_f: "Feminino",
    gender_d: "Diverso",
    address: "Endereço",
    notes_field: "Notas",
    link_bio: "Vincular Bioimpedância",
    linked_bio: "Bioimpedância vinculada",
    no_clients: "Nenhum cliente registrado",
    email_templates: "Modelos de E-mail",
    new_template: "Novo Modelo",
    edit_template: "Editar Modelo",
    template_name: "Nome do modelo",
    subject: "Assunto",
    body: "Conteúdo",
    automated: "Automatizado",
    trigger_type: "Gatilho",
    trigger_birthday: "Aniversário",
    trigger_assessment: "Lembrete de avaliação",
    trigger_welcome: "Boas-vindas",
    trigger_custom: "Personalizado",
    days_before: "Dias antes",
    send_email: "Enviar e-mail",
    send_to_selected: "Enviar aos selecionados",
    generate_with_ai: "Gerar com IA",
    ai_prompt: "Descreva o e-mail...",
    email_logs: "Histórico de e-mails",
    queued: "Na fila",
    sent: "Enviado",
    clients_tab: "Clientes",
    emails_tab: "E-mails",
    templates_tab: "Modelos",
    select_all: "Selecionar todos",
    no_email: "Sem e-mail",
  }
};
